var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 233,
    viewBox: "0 0 92 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.3206 232.557H0.185547V226.358H33.3206C44.1324 226.358 52.9284 217.579 52.9284 206.787V26.2124C52.9284 15.4211 44.1324 6.64161 33.3206 6.64161H0.315454V0.442871H33.3206C47.5561 0.442871 59.1389 12.0038 59.1389 26.2124V206.787C59.1389 220.996 47.5561 232.557 33.3206 232.557Z",
    fill: "#E64C4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M91.6371 116.534L71.4678 104.35V128.714L91.6371 116.534Z",
    fill: "#E64C4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M83.0173 112.409H53.9387V120.658H83.0173V112.409Z",
    fill: "#E64C4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group (3).f8d0fc93c3b9b1c6e281e317777af04a.svg";
export { ForwardRef as ReactComponent };